import { END_POINTS } from '../constants/urls';
import { CommonBody, FaqRes, CMS, GetFaqResponse } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

interface GetCmsResponse {
  _id: string;
  email: string;
  phone: string;
  terms: string;
  privacyPolicy: string;
  aboutUs: string;
  dialCode: string;
  loyaltyPointsInAed?: number;
}

export interface GetSettingResponse {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export const faqApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCms: builder.query<CommonResponse & { data: GetCmsResponse }, {}>({
      query: () => ({
        url: END_POINTS.getCms,
        method: 'GET',
      }),
    }),
    updateCms: builder.mutation<CommonResponseType & { data: CMS }, { body: CMS, id: string }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.getCms}/${id}`,
        method: 'PUT',
        body,
      }),
    }),
    getFAQ: builder.query<
      CommonResponseType & { data: GetFaqResponse },
      {
        search: string;
        page: number;
      }
    >({
      query: ({ search, page }) => {
        const skip = (page ? page - 1 : 0) * 10;
        const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
        return {
          url: `${END_POINTS.getFaqs}?skip=${skip}${searchParam}`,
          method: 'GET',
        };
      },
    }),
    addFAQ: builder.mutation<CommonResponseType & { data: any }, { body: CommonBody }>({
      query: ({ body }) => ({
        url: END_POINTS.getFaq,
        method: 'POST',
        body,
      }),
    }),
    updateFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.getFaq}`,
        method: 'PUT',
        body,
      }),
    }),
    deleteFaq: builder.mutation<
      CommonResponseType & { data: FaqRes },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getFaq}/${id}`,
        method: 'DELETE',
        body: {},
      }),
    }),
  }),
});

export const {
  useLazyGetCmsQuery,
  useUpdateCmsMutation,
  useAddFAQMutation,
  useUpdateFaqMutation,
  useLazyGetFAQQuery,
  useDeleteFaqMutation
} = faqApi;
